import { useContext, useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import moment from "moment";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import { GlobalContext } from "../../../../context/Context";
import { Brand, DateRange, Service } from "../../../../component/icons/filter-icon";

const ComparisionProduct = () => {
  let {state} = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [footer, setFooter] = useState({})
  const [defaultRange, setDefaultRange] = useState("");

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-ppc-product-comparison${extraUrl}`,
      });
      setList(res);
      // setTableHeaders(res.headers);
      // setSaveFilter(res?.custom_filters);
      // setFooter(res?.footer)
      
      if(!filterReturn?.find(eachFilter => eachFilter?.name == "prodcut_id")?.value?.length){

        setFilterReturn((prev) => [...prev, {
          name: "prodcut_id",
          label: "Product",
          options: ["is"],
          selectedOpt: "is",
          value: res?.products?.map((eachPro) => eachPro?.id),
          type: "dropdown",
          dropdown: state?.getDropdowns?.serviceList || res?.products,
          dropdownKey: "name",
          dropdownVal: "id",
          isMulti: true,
          isChecked: true,
          Icon: Service
        }])
      }
      
      setIsLoading(false);
      setDefaultRange(res?.date_filter)
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {

    if(filterReturn?.find(eachFilter => eachFilter?.name == "prodcut_id")?.value?.length){

      const productFilter = filterReturn?.find((eachData) => eachData?.name == "prodcut_id");


      setFilterReturn((prev) => [...prev?.filter((eachData) => eachData?.name != "prodcut_id"), {
       ...productFilter,
        dropdown: state?.getDropdowns?.serviceList
      }])

    }

  } , [state?.getDropdowns?.serviceList?.length, isLoading])

  const filterModalData = [
    {
      name: "prodcut_id",
      label: "Product",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.serviceList,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: Service
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    }
  ];

  console.log("filterReturn", filterReturn)

  const metrics = [
    { key: "website_count", label: "Website Count"},
    { key: "spend", label: "Spend" },
    { key: "conversions", label: "Conversions" },
    { key: "roas", label: "ROAS" },
    { key: "cpl", label: "CPL" },
    { key: "ctr", label: "CTR" },
    { key: "cpa", label: "CPA" }
  ];

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length) ?
            [
              {
                "name": "date_range",
                "label": "Date Range",
                "selectedOpt": "is",
                "value": defaultRange,
                "isCrossDisable": true
              },
              ...filterReturn
            ]
            : filterReturn
          }
          onChange={(filters) => {
            setFilterReturn(filters);
            getData({ filter: filters });
          }}
        />
        <div className={Style.report_table__header}>
          <TitleHeading title={'Product Comparisions'} />

          <div className={Style.bpfl_action}>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.product_comparison?.length ? (
            <div className="w-full h-full flex items-center justify-center">
              <DataNotFound title={"Lists"} />
            </div>
          ) : (
            <>
              <TableCard>
                <Table>
                  <TableHead>
                    {/* <TableRow>
                      <TableCell header sticky><TableHeaderWrap><span className="w-[28px]"></span> Brand</TableHeaderWrap></TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow> */}
                    <TableRow>
                      <TableCell header sticky><TableHeaderWrap></TableHeaderWrap></TableCell>
                      {lists?.product_comparison?.map((item, i) => (
                        <TableCell header key={i}>
                          {item.product}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {metrics.map((metric) => (
                      <TableRow key={metric.key}>
                        <TableCell sticky className={"!bg-[#F7F7F7]"}>
                          <div className="flex items-center gap-[10px]">
                            <div className="font-[600] text-[#000] text-[15px]">{metric.label}</div>
                          </div>
                        </TableCell>

                        {lists?.product_comparison.map((item) => (
                          <TableCell
                            key={`${item.product}-${metric.key}`}
                          >
                            {item[metric.key] ?? 0}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-brand-performance-analysis"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl="get-brand-performance-analysis"
        />
      )}
    </>
  );
};

export default ComparisionProduct;
